export default {"src":"/_next/static/media/restaurant.6bdcc562.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};